module.exports = __webpack_public_path__ + "img/about_img01.249351a5.png";